import { startOfDay, endOfDay } from 'date-fns';
import apiService from '@/core/common/services/api.service';
import { getReisetermin } from '@/core/common/services/odata.service';

// Hier werden zu einer Liste von Alternativterminen die bereits angelegten Reisetermine ermittelt
// Damit lässt sich je Alternativtermin anzeigen, ob es den Termin schon gibt und in welchem Status
export async function getExistierendeReisetermine(reisekuerzel, datumsListe = []) {
  if (!reisekuerzel || !datumsListe.length) {
    return [];
  }
  // Der Server filtert nur den Zeitraum, den exakten Abgleich je Alternativtermin macht die Komponente
  const datumsWerte = datumsListe.map(datum => new Date(datum)).sort((a, b) => a - b);
  const response = await getReisetermin({
    filter: {
      'reise/reisekuerzel': reisekuerzel,
      abreisedatum: {
        ge: startOfDay(datumsWerte[0]),
        le: endOfDay(datumsWerte[datumsWerte.length - 1]),
      },
      isDeleted: false,
    },
    select: ['id', 'abreisedatum', 'state', 'reiseterminkuerzel'],
  });

  return response?.data ?? [];
}

// In dieser Funktion wird der gewählte Alternativtermin des CM gespeichert
export async function speichereAlternativtermin({ bearbeitungId, abreisedatum }) {
  return apiService.post('Reisetermin/alternativtermin-erstellen', {
    reiseterminCountryManagerBearbeitungId: bearbeitungId,
    gewaehltesAbreisedatumAlternativtermin: abreisedatum,
  });
}
